import { useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { Pagination } from '../../components/Pagination';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import useQueryString from 'utils/hooks/useQueryString';
import queryString from 'query-string';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { NoticeListItem } from './NoticeListItem';


export const NoticeList = ()=>{
    const navigate = useNavigate();
    const { school } = useParams();
    const queryParams = useQueryString();
    
    const fetchData = useMemo(() => {
        //검증
        let tempPage = Number(queryParams.page);
        let tempType = queryParams.type;
        if( Number.isNaN(tempPage)) tempPage=0;
        if( tempType===undefined || tempType===null || tempType==='')tempType=null;
        return {page:tempPage, type:tempType, school:school};
    }, [queryParams, school]);


    const { data:noticeList, isFetching, isError, error, isSuccess} =useQuery({
        queryKey:['notice/list', fetchData],
        queryFn:()=>Api.post(`/api/notice/list?page=${fetchData.page}`, fetchData),
        placeholderData:keepPreviousData,
    });

    
    // 페이지 이동 (주소만 변경)
    const fetchList = (page = 0)=>{
        let tempSearchOption = {...fetchData, page:page };
        navigate(`/${ school }/notice?${queryString.stringify(tempSearchOption)}`);
    }

    // 굳이memo 안써도 될꺼 같기도?
    const noticeListElement = useMemo(() => {
        if(isError){
            return (
                <tr>
                    <td colSpan="5">
                        <ErrorMessageBox  message={createFetchErrorMessage(error).message}
                            goto={<Link to={`/${school}/notice`} className="btn _border">목록</Link>
                        }  />
                    </td>
                </tr>
            );           
        }
        if(noticeList?.data?.list.length<=0){
            if(isFetching)return null;
            return <div className="no_data"><p>게시글이 없습니다.</p></div>;
        }
        
        
        return noticeList?.data?.list.map((notice, key) => {
            return <NoticeListItem notice={notice} school={school} key={key} />;
        });
    }, [isError, noticeList, error, school, isFetching]);

    return (
        <div className="section">
            <div className="inner">
                <div className="bbs_nav">
                    <ul>
                        <li className={ (fetchData.type===''||fetchData.type===undefined)?'on':''}>
                            <Link className="btn _sm _border" to={`/${school}/notice?type=`}>전체</Link>
                        </li>
                        <li className={fetchData.type==='NOTICE_TOP'?'on':''}>
                            <Link className="btn _sm _border" to={`/${school}/notice?type=NOTICE_TOP`}>공지</Link>
                        </li>
                        <li className={fetchData.type==='EVENT_RESULT'?'on':''}>
                            <Link className="btn _sm _border" to={`/${school}/notice?type=EVENT_RESULT`}>수상</Link>
                        </li>
                        <li className={fetchData.type==='EVENT'?'on':''}>
                            <Link className="btn _sm _border" to={`/${school}/notice?type=EVENT`}>독서행사</Link>
                        </li>
                        <li className={fetchData.type==='EVENT_PUB'?'on':''}>
                            <Link className="btn _sm _border" to={`/${school}/notice?type=EVENT_PUB`}>문학행사</Link>
                        </li>
                        
                    </ul>
                </div>
                <div className="bbs_list">
                    <div className="list devision">
                        <div className="num">번호</div>
                        <div className="type">구분</div>
                        <div className="title">제목</div>
                        <div className="hit">조회</div>
                        <div className="date">등록일</div>
                    </div>
                    {noticeListElement}
                    <Loading overlay={true} active={isFetching} />
                </div>
                
                {isSuccess && <Pagination page={noticeList.data?.page} totalPage={noticeList.data?.totalPages} gotoPage={fetchList} />}
                
            </div>
        </div>
    );
}